import { 
    GET_ALL_REPORTS,
    SET_MONTH,
    SET_YEAR,
    GET_JOBPACK_REPORTS ,
    GET_HSQE_TEMPLATE,
    SET_SPECIFIC_TEMPLATE,
    GET_USERS_PROFILE
} from "./types";
import moment from "moment";

const INITIAL_STATE = {
    requesting: false,
    month: moment().format("MMM").toLowerCase(),
    year: moment().format("YYYY"),
    reports: false,
    jobPackReports: false,
    template: false,
    specificTemplate: false,
    users : false,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_ALL_REPORTS.REQUEST: {
            return { ...state, requesting: true, reports: false };
        }
        case GET_ALL_REPORTS.FAIL: {
            return { ...state, requesting: false, reports: false };
        }
        case GET_ALL_REPORTS.SUCCESS: {
            return { ...state, requesting: false, reports: action.payload };
        }
        case SET_MONTH: {
            return { ...state, month: action.payload };
        }
        case SET_YEAR: {
            return { ...state, year: action.payload };
        }
        case GET_JOBPACK_REPORTS.REQUEST: {
            return { ...state, requesting: true, jobPackReports: false };
        }
        case GET_JOBPACK_REPORTS.FAIL: {
            return { ...state, requesting: false, jobPackReports: false };
        }
        case GET_JOBPACK_REPORTS.SUCCESS: {
            return {
                ...state,
                requesting: false,
                jobPackReports: action.payload,
            };
        }
        case SET_SPECIFIC_TEMPLATE.REQUEST: {
            return { ...state, requesting: true, specificTemplate: false };
        }
        case SET_SPECIFIC_TEMPLATE.FAIL: {
            return { ...state, requesting: false, specificTemplate: false };
        }
        case SET_SPECIFIC_TEMPLATE.SUCCESS: {
            return { ...state, requesting: false, specificTemplate: action.payload };
        }
        case GET_HSQE_TEMPLATE.REQUEST: {
            return { ...state, requesting: true, template: false };
        }
        case GET_HSQE_TEMPLATE.FAIL: {
            return { ...state, requesting: false, template: false };
        }
        case GET_HSQE_TEMPLATE.SUCCESS: {
            return { ...state, requesting: false, template: action.payload };
        }
        case GET_USERS_PROFILE.REQUEST: {
            return { ...state, requesting: true, users: false };
        }
        case GET_USERS_PROFILE.FAIL: {
            return { ...state, requesting: false, users: false };
        }
        case GET_USERS_PROFILE.SUCCESS: {
            return { ...state, requesting: false, users: action.payload };
        }
        default: {
            return state;
        }
    }
};
